$("#addCuttingToolForm").submit(function (e) {

    var form = $(this);
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    $.ajax({
        type: "POST",
        url: "/cutting_tools/store",
        data: form.serialize(), // serializes the form's elements.
        success: function (result) {
            document.getElementById('statusMsg').innerHTML = '<div class="bg-success" style="padding: 10px 5px;">Cutting Tool added.</div>';
            $('#addCuttingToolForm').trigger("reset");
            $('#toolRefreshButton').trigger("click");
            setTimeout(function () {
                document.getElementById("statusMsg").innerHTML = '';
            }, 3000);
        },
        error: function (result) {
            var errors = result.responseJSON;
            var count = Object.keys(errors).length;
            var message = '';
            for (i = 0; i < count; i++) {
                if (i > 0) {
                    message += '<br />';
                }
                message += (errors[Object.keys(errors)[i]][0]);
            }
            document.getElementById("statusMsg").innerHTML = '<div class="alert alert-danger" style="padding: 10px 5px;">' + message + '</div>';
        }

    });

    e.preventDefault(); // avoid to execute the actual submit of the form.
});
